import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
    state : {
        recent_word:localStorage.recent_word||'',
        unionid:localStorage.unionid,
        status:localStorage.status
    },
    mutations: {
        setRecentWord(state,data){
			if(state.recent_word.indexOf(data)==-1){
				if(state.recent_word==''){
					state.recent_word = state.recent_word+data
				}else{
					state.recent_word = state.recent_word+','+data
				}
				localStorage.recent_word = state.recent_word
			}
        },
        clearRecentWord(state) {
            state.recent_word = ''
        },
        setunionid(state,data){
            state.unionid = data
            localStorage.unionid = data
        },
        setstatus(state,data){
            state.status = data
            localStorage.status = data
        }
    } 
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js